import React from 'react';
import Link from 'next/link';
import * as S from './Breadcrumbs.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { Breadcrumb } from '@/components/Breadcrumbs/Breadcrumbs.types';

interface BreadcrumbsProps {
  hasBg?: boolean;
  nestingLvl?: number;
  breadcrumbs?: Breadcrumb[];
  hasHorizontalPadding?: boolean;
  isHidden?: boolean;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  hasHorizontalPadding,
  hasBg,
  nestingLvl = 3,
  breadcrumbs = [],
  isHidden = false,
}: BreadcrumbsProps) => {
  if (!breadcrumbs.length && !isHidden) {
    return (
      <S.BreadcrumbsSkeleton
        $hasHorizontalPadding={hasHorizontalPadding}
        data-testid="breadcrumbs-skeleton-loader"
      >
        {Array.from({ length: nestingLvl }, (_, index) => (
          <SkeletonLoader width="115px" height="18px" key={index} />
        ))}
      </S.BreadcrumbsSkeleton>
    );
  }

  return (
    <S.BreadcrumbsBox
      data-testid="breadcrumbs-box"
      $hasHorizontalPadding={hasHorizontalPadding}
      $hasBg={hasBg}
      $isHidden={isHidden}
    >
      {breadcrumbs.map(({ label, link }, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <React.Fragment key={label}>
            <S.BreadcrumbsLabel
              data-testid="breadcrumbs-label"
              $variant="1"
              {...(link && { as: Link, href: link })}
            >
              {label}
            </S.BreadcrumbsLabel>
            {!isLast && (
              <S.BreadcrumbsLabel $variant="1">&#x2022;</S.BreadcrumbsLabel>
            )}
          </React.Fragment>
        );
      })}
    </S.BreadcrumbsBox>
  );
};
